<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <span
          v-if="item.text === 'Hoje'"
          class="ml-n2 mt-3"
          style="
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 0.875rem;
          "
        >
          {{ this.diaSemana }}, {{ this.dia }} de {{ this.mes }} de
          {{ this.ano }}
        </span>
        <span
          v-else-if="item.text === 'Amanhã'"
          class="ml-n2 mt-3"
          style="
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 0.875rem;
          "
        >
          {{ this.diaSemana }}, {{ this.dia }} de {{ this.mes }} de
          {{ this.ano }}
        </span>
        <span
          v-else
          class="ml-n2 mt-3"
          style="
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 0.875rem;
            color: transparent;
          "
        >
          <br />
        </span>
      </v-col>
      <v-col cols="12" style="overflow-x: auto" class="mt-n6">
        <!--        :class="item.text === '15 dias' ? 'ml-n10' : 'ml-n13'"-->
        <div
          id="chart-weather-forecast"
          :style="
            item.text === '15 dias'
              ? 'min-width: 1100px'
              : item.text === 'Amanhã'
              ? 'min-width: 2000px'
              : this.arrayTempHoje.length <= 15
              ? 'min-width: 1100px'
              : 'min-width: 2000px'
          "
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*eslint-disable*/
import Highcharts from "highcharts";
import Acessibility from "highcharts/modules/accessibility";
import moment from "moment";
Acessibility(Highcharts);
export default {
  props: ["cityId", "item"],
  name: "ChartWeatherForecast",
  data: () => ({
    arrayPrecHoje: [],
    arrayPrecAmanha: [],
    arrayTempHoje: [],
    arrayTempAmanha: [],
    tempSorted: [],
    arrayPrecDaily: [],
    arrayTempMin: [],
    arrayTempMax: [],
    caption: undefined,
    dia: undefined,
    summaryIdHourly: undefined,
    summaryIdDaily: undefined,
    icone: undefined,
    diaSemana: undefined,
    mes: undefined,
    ano: undefined,
    tomorrow: moment()
      .tz("America/Sao_Paulo")
      .locale("pt-br")
      .add(1, "days")
      .format("YYYY-MM-DDTHH:mm:ss"),
  }),
  watch: {
    item(value) {
      if (value) {
        this.initialize();
      }
    },
    cityId(value) {
      if (value) {
        this.initialize();
      }
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    dateFormatted() {
      let x;
      if (this.item.text === "15 dias") {
        x = "dddd, DD/MM/YYYY";
      } else {
        x = "DD/MM/YYYY HH:mm";
      }
      return x;
    },
    async initialize() {
      await this.$store.dispatch("loadDailyForecastWeather", {
        id: this.cityId,
      });
      await this.$store.dispatch("loadHourlyForecastWeather", {
        id: this.cityId,
      });
      this.arrayPrecHoje = [];
      this.arrayPrecAmanha = [];
      this.arrayTempHoje = [];
      this.arrayTempAmanha = [];
      this.arrayPrecDaily = [];
      this.arrayTempMax = [];
      this.arrayTempMin = [];

      const resDaily = await this.$store.getters.dailyForecastWeather;
      const resHourly = await this.$store.getters.hourlyForecastWeather;

      let Dateformat = this.dateFormatted();
      this.dia = moment().tz("America/Sao_Paulo").format("DD");
      this.diaSemana = moment().tz("America/Sao_Paulo").locale("pt-br").format("dddd");
      this.mes = moment()
        .tz("America/Sao_Paulo")
        .locale("pt-br")
        .format("MMMM")
      this.ano = moment().tz("America/Sao_Paulo").format("YYYY");
      //tomorrow
      if (this.item.text === "Amanhã") {
        this.dia = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
          .tz("America/Sao_Paulo")
          .format("DD")
        this.diaSemana = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
          .tz("America/Sao_Paulo")
          .locale("pt-br")
          .format("dddd");
        this.mes = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
          .tz("America/Sao_Paulo")
          .locale("pt-br")
          .format("MMMM")
        this.ano = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
          .tz("America/Sao_Paulo")
          .format("YYYY")
      }
      //tomorrow

      let iconsHourly = {};
      if (this.item.text === "Hoje") {
        this.caption = {
          text: `Previsão horária para o dia ${this.dia} de ${this.mes} de ${this.ano}`,
          style: { color: '#FFFFFF'}
        };
        let position, lastPosition;
        let lastOfDay = moment().tz("America/Sao_Paulo").format("YYYY-MM-DDT23");
        let nowDate = moment().tz("America/Sao_Paulo").format("YYYY-MM-DDTHH");
        for (let item in resHourly) {
          if (
            moment(resHourly[item].datetime)
              .tz("America/Sao_Paulo")
              .format("YYYY-MM-DDTHH") === nowDate
          ) {
            position = item;
          }
          if (
            moment(resHourly[item].datetime)
              .tz("America/Sao_Paulo")
              .format("YYYY-MM-DDTHH") === lastOfDay
          ) {
            lastPosition = item;
          }
        }
        for (let index = position; index <= Number(lastPosition); index++) {
          let itemHourly = {
            icon: this.mapIcon(
              resHourly[index].value.summaryId,
              resHourly[index].datetime
            ),
            text: this.mapText(resHourly[index].value.summaryId),
            id: resHourly[index].value.summaryId,
            date: resHourly[index].datetime,
          };
          let dateF = new Date(resHourly[index].datetime).getTime();
          iconsHourly[dateF] = itemHourly;
          this.arrayPrecHoje.push([
            new Date(resHourly[index].datetime).getTime(),
            resHourly[index].value.precIntensity,
          ]);
          this.arrayTempHoje.push([
            new Date(resHourly[index].datetime).getTime(),
            resHourly[index].value.temp,
          ]);
        }

        Highcharts.setOptions({
          lang: {
            months: [
              "Janeiro",
              "Fevereiro",
              "Março",
              "Abril",
              "Maio",
              "Junho",
              "Julho",
              "Agosto",
              "Setembro",
              "Outubro",
              "Novembro",
              "Dezembro",
            ],
            shortMonths: [
              "Jan",
              "Fev",
              "Mar",
              "Abr",
              "Mai",
              "Jun",
              "Jul",
              "Ago",
              "Set",
              "Out",
              "Nov",
              "Dez",
            ],
            weekdays: [
              "Domingo",
              "Segunda",
              "Terça",
              "Quarta",
              "Quinta",
              "Sexta",
              "Sábado",
            ],
          },
        });

        Highcharts.chart("chart-weather-forecast", {
          chart: {
            backgroundColor: "transparent",
          },
          title: { text: null },
          subtitle: { text: null },
          credits: {
            enabled: false,
            href: "http://www.simepar.br/",
            text: "by: SIMEPAR",
            style: { color: "#FFFFFF" },
          },
          legend: {
            enabled: false,
            itemStyle: { color: "#FFFFFF" },
            itemHoverStyle: { color: "#979797" },
          },
          xAxis: {
            opposite: true,
            lineColor: "transparent",
            gridLineColor: "transparent",
            minorGridLineColor: "transparent",
            tickColor: "transparent",
            visible: true,
            labels: {
              useHTML: true,
              formatter: function () {
                if (
                  iconsHourly[this.value].icon !== " " &&
                  iconsHourly[this.value].text !== " "
                ) {
                  return (
                    '<span style="color: #FFFFFF; font-size: 16px; font-weight: bold;">' +
                    moment(iconsHourly[this.value].date, "YYYY-MM-DDTHH:mm:ssZ")
                      .tz("America/Sao_Paulo")
                      .format("HH:mm") +
                    "</span>" +
                    "<br>" +
                    '<i class="' +
                    iconsHourly[this.value].icon +
                    '" style="color: #FFFFFF; font-size: 40px"></i>'
                  );
                } else {
                  return (
                    '<span style="color: #FFFFFF; font-size: 16px; font-weight: bold;">' +
                    moment(iconsHourly[this.value].date, "YYYY-MM-DDTHH:mm:ssZ")
                      .tz("America/Sao_Paulo")
                      .format("HH:mm") +
                    "</span>" +
                    "<br>" +
                    '<i class="icon-infohidro-wi-day-cloudy" style="color: transparent; font-size: 40px"></i>'
                  );
                }
              },
            },
            type: "datetime",
            /*labels: {
              enabled: true,
              format: "{value:%H:%M}",
              style: { color: "#FFFFFF" },
            },*/
            title: {
              enabled: false,
              style: { color: "#FFFFFF" },
            },
          },
          yAxis: [
            {
              visible: false,
              reversed: false,
              opposite: false,
              min: 0,
              height: "70%",
            },
            {
              visible: false,
              reversed: true,
              opposite: true,
              min: 0,
              top: "60%",
              height: "30%",
              offset: 0,
            },
          ],
          plotOptions: {
            series: {
              marker: { enabled: true },
            },
          },
          colors: ["#0071B0", "#FF9F00"],
          tooltip: {
            useHTML: true,
            backgroundColor: "#212a35",
            borderWidth: 0,
            formatter: function () {
              return this.points.reduce(function (s, point) {
                return (
                  s +
                  '<div style="background-color: #212a35">' +
                  "<br/>" +
                  '<b style="color:' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ": " +
                  "</b>" +
                  '<b style="color: #FFFFFF">' +
                  point.y.toFixed(point.series.tooltipOptions.valueDecimals) +
                  point.series.tooltipOptions.valueSuffix +
                  "</b>"
                );
              }, '<b style="text-transform: capitalize; color: #FFFFFF">' +
                moment.utc(this.x).tz("America/Sao_Paulo").format(Dateformat) +
                "</b>" +
                "<br/>" +
                '<b style="color: #FFFFFF">' +
                iconsHourly[this.x].text +
                "</b>" +
                "<br/>" +
                "</div>");
            },
            shared: true,
            crosshairs: true,
          },
          series: [
            {
              name: "Precipitação",
              type: "column",
              yAxis: 1,
              data: this.arrayPrecHoje,
              tooltip: {
                valueDecimals: 1,
                valueSuffix: "mm",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}mm',
                formatter: function () {
                  return this.y.toFixed(1) + "mm";
                },
                verticalAlign: "top",
                style: { color: "#FFFFFF" },
              },
            },
            {
              name: "Temperatura",
              type: "line",
              yAxis: 0,
              data: this.arrayTempHoje,
              tooltip: {
                valueDecimals: 0,
                valueSuffix: "°C",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}˚C',
                formatter: function () {
                  return this.y.toFixed(0) + "˚C";
                },
                verticalAlign: "bottom",
                style: { color: "#FFFFFF" },
              },
            },
          ],
          caption: this.caption,
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  plotOptions: {
                    series: {
                      marker: {
                        radius: 2.5,
                      },
                    },
                  },
                },
              },
            ],
          },
          exporting: {
            enabled: false,
          },
        });
      } else if (this.item.text === "Amanhã") {
        this.caption = {
          text: `Previsão horária para Amanhã ${this.dia} de ${this.mes} de ${this.ano}`,
          style: { color: '#FFFFFF'}
        };
        let position, lastPosition;
        let lastOfDay = moment()
          .add(1, "day")
          .tz("America/Sao_Paulo")
          .format("YYYY-MM-DDT23");
        let initialOfDay = moment()
          .add(1, "day")
          .tz("America/Sao_Paulo")
          .format("YYYY-MM-DDT00");
        for (let item in resHourly) {
          if (
            moment(resHourly[item].datetime)
              .tz("America/Sao_Paulo")
              .format("YYYY-MM-DDTHH") === initialOfDay
          ) {
            position = item;
          }
          if (
            moment(resHourly[item].datetime)
              .tz("America/Sao_Paulo")
              .format("YYYY-MM-DDTHH") === lastOfDay
          ) {
            lastPosition = item;
          }
        }
        for (let index = position; index <= Number(lastPosition); index++) {
          let itemHourly = {
            icon: this.mapIcon(
              resHourly[index].value.summaryId,
              resHourly[index].datetime
            ),
            text: this.mapText(resHourly[index].value.summaryId),
            id: resHourly[index].value.summaryId,
            date: resHourly[index].datetime,
          };
          let dateF = new Date(resHourly[index].datetime).getTime();
          iconsHourly[dateF] = itemHourly;
          this.arrayPrecAmanha.push([
            new Date(resHourly[index].datetime).getTime(),
            resHourly[index].value.precIntensity,
          ]);
          this.arrayTempAmanha.push([
            new Date(resHourly[index].datetime).getTime(),
            resHourly[index].value.temp,
          ]);
        }

        Highcharts.setOptions({
          lang: {
            months: [
              "Janeiro",
              "Fevereiro",
              "Março",
              "Abril",
              "Maio",
              "Junho",
              "Julho",
              "Agosto",
              "Setembro",
              "Outubro",
              "Novembro",
              "Dezembro",
            ],
            shortMonths: [
              "Jan",
              "Fev",
              "Mar",
              "Abr",
              "Mai",
              "Jun",
              "Jul",
              "Ago",
              "Set",
              "Out",
              "Nov",
              "Dez",
            ],
            weekdays: [
              "Domingo",
              "Segunda",
              "Terça",
              "Quarta",
              "Quinta",
              "Sexta",
              "Sábado",
            ],
          },
        });

        Highcharts.chart("chart-weather-forecast", {
          chart: {
            backgroundColor: "transparent",
          },
          title: { text: null },
          subtitle: { text: null },
          credits: {
            enabled: false,
            href: "http://www.simepar.br/",
            text: "by: SIMEPAR",
            style: { color: "#FFFFFF" },
          },
          legend: {
            enabled: false,
            itemStyle: { color: "#FFFFFF" },
            itemHoverStyle: { color: "#979797" },
          },
          xAxis: {
            opposite: true,
            lineColor: "transparent",
            gridLineColor: "transparent",
            minorGridLineColor: "transparent",
            tickColor: "transparent",
            visible: true,
            labels: {
              useHTML: true,
              formatter: function () {
                if (
                  iconsHourly[this.value].icon !== " " &&
                  iconsHourly[this.value].text !== " "
                ) {
                  return (
                    '<span style="color: #FFFFFF; font-size: 16px; font-weight: bold;">' +
                    moment(iconsHourly[this.value].date, "YYYY-MM-DDTHH:mm:ssZ")
                      .tz("America/Sao_Paulo")
                      .format("HH:mm") +
                    "</span>" +
                    "<br>" +
                    '<i class="' +
                    iconsHourly[this.value].icon +
                    '" style="color: #FFFFFF; font-size: 40px"></i>'
                  );
                } else {
                  return (
                    '<span style="color: #FFFFFF; font-size: 16px; font-weight: bold;">' +
                    moment(iconsHourly[this.value].date, "YYYY-MM-DDTHH:mm:ssZ")
                      .tz("America/Sao_Paulo")
                      .format("HH:mm") +
                    "</span>" +
                    "<br>" +
                    '<i class="icon-infohidro-wi-day-cloudy" style="color: transparent; font-size: 40px"></i>'
                  );
                }
              },
            },
            type: "datetime",
            /*            labels: {
              enabled: true,
              format: "{value:%H:%M}",
              style: { color: "#FFFFFF" },
            },*/
            title: {
              enabled: false,
              style: { color: "#FFFFFF" },
            },
          },
          yAxis: [
            {
              visible: false,
              reversed: false,
              opposite: false,
              min: 0,
              height: "70%",
            },
            {
              visible: false,
              reversed: true,
              opposite: true,
              min: 0,
              top: "60%",
              height: "30%",
              offset: 0,
            },
          ],
          plotOptions: {
            series: {
              marker: { enabled: true },
            },
          },
          colors: ["#0071B0", "#FF9F00"],
          tooltip: {
            useHTML: true,
            backgroundColor: "#212a35",
            borderWidth: 0,
            formatter: function () {
              return this.points.reduce(function (s, point) {
                return (
                  s +
                  '<div style="background-color: #212a35">' +
                  "<br/>" +
                  '<b style="color:' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ": " +
                  "</b>" +
                  '<b style="color: #FFFFFF">' +
                  point.y.toFixed(point.series.tooltipOptions.valueDecimals) +
                  point.series.tooltipOptions.valueSuffix +
                  "</b>"
                );
              }, '<b style="text-transform: capitalize; color: #FFFFFF">' +
                moment.utc(this.x).tz("America/Sao_Paulo").format(Dateformat) +
                "</b>" +
                "<br/>" +
                '<b style="color: #FFFFFF">' +
                iconsHourly[this.x].text +
                "</b>" +
                "<br/>" +
                "</div>");
            },
            shared: true,
            crosshairs: true,
          },
          series: [
            {
              name: "Precipitação",
              type: "column",
              yAxis: 1,
              data: this.arrayPrecAmanha,
              tooltip: {
                valueDecimals: 1,
                valueSuffix: "mm",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}mm',
                formatter: function () {
                  return this.y.toFixed(1) + "mm";
                },
                verticalAlign: "top",
                style: { color: "#FFFFFF" },
              },
            },
            {
              name: "Temperatura",
              type: "line",
              yAxis: 0,
              data: this.arrayTempAmanha,
              tooltip: {
                valueDecimals: 0,
                valueSuffix: "°C",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}˚C',
                formatter: function () {
                  return this.y.toFixed(0) + "˚C";
                },
                verticalAlign: "bottom",
                style: { color: "#FFFFFF" },
              },
            },
          ],
          caption: this.caption,
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  plotOptions: {
                    series: {
                      marker: {
                        radius: 2.5,
                      },
                    },
                  },
                },
              },
            ],
          },
          exporting: {
            enabled: false,
          },
        });
      } else if (this.item.text === "15 dias") {
        // icon/tooltip/date
        this.caption = {
          text: "Previsão para 15 dias",
          style: { color: '#FFFFFF'}
        };
        let iconsDaily = {};
        for (let item in resDaily) {
          let itemDaily = {
            icon: this.mapIcon(resDaily[item].value.summaryId, resDaily[item].date),
            text: this.mapText(resDaily[item].value.summaryId),
            id: resDaily[item].value.summaryId,
            date: resDaily[item].date,
          };
          let dateF = this.dateToUTC(resDaily[item].date);
          iconsDaily[dateF] = itemDaily;
        }
        // icon/tooltip/date
        for (let index in resDaily) {
          this.arrayPrecDaily.push([
            this.dateToUTC(resDaily[index].date),
            resDaily[index].value.precIntensity,
          ]);
          this.arrayTempMax.push([
            this.dateToUTC(resDaily[index].date),
            resDaily[index].value.tempMax,
          ]);
          this.arrayTempMin.push([
            this.dateToUTC(resDaily[index].date),
            resDaily[index].value.tempMin,
          ]);
        }
        Highcharts.setOptions({
          lang: {
            months: [
              "Janeiro",
              "Fevereiro",
              "Março",
              "Abril",
              "Maio",
              "Junho",
              "Julho",
              "Agosto",
              "Setembro",
              "Outubro",
              "Novembro",
              "Dezembro",
            ],
            shortMonths: [
              "Jan",
              "Fev",
              "Mar",
              "Abr",
              "Mai",
              "Jun",
              "Jul",
              "Ago",
              "Set",
              "Out",
              "Nov",
              "Dez",
            ],
            shortWeekdays: ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"],
          },
        });

        Highcharts.chart("chart-weather-forecast", {
          chart: {
            backgroundColor: "transparent",
          },
          title: { text: null },
          subtitle: { text: null },
          credits: {
            enabled: false,
            href: "http://www.simepar.br/",
            text: "by: SIMEPAR",
            style: { color: "#FFFFFF" },
          },
          legend: {
            enabled: false,
            itemStyle: { color: "#FFFFFF" },
            itemHoverStyle: { color: "#979797" },
          },
          xAxis: {
            opposite: true,
            lineColor: "transparent",
            gridLineColor: "transparent",
            minorGridLineColor: "transparent",
            tickColor: "transparent",
            visible: true,
            labels: {
              useHTML: true,
              formatter: function () {
                if (
                  iconsDaily[this.value].icon !== " " &&
                  iconsDaily[this.value].text !== " "
                ) {
                  return (
                    '<span style="color: #FFFFFF; font-size: 14px">' +
                    moment(iconsDaily[this.value].date, "YYYY-MM-DD")
                      .tz("America/Sao_Paulo")
                      .format("DD/MM") +
                    "</span>" +
                    "<br>" +
                    '<span style="color: #FFFFFF; text-transform: capitalize; font-size: 16px; font-weight: bold;">' +
                    moment(iconsDaily[this.value].date, "YYYY-MM-DD")
                      .tz("America/Sao_Paulo")
                      .locale("pt-br")
                      .format("ddd") +
                    "</span>" +
                    "<br>" +
                    '<i class="' +
                    iconsDaily[this.value].icon +
                    '" style="color: #FFFFFF; font-size: 40px"></i>'
                  );
                } else {
                  return (
                    '<span style="color: #FFFFFF; font-size: 14px">' +
                    moment(iconsDaily[this.value].date, "YYYY-MM-DD")
                      .tz("America/Sao_Paulo")
                      .format("DD/MM") +
                    "</span>" +
                    "<br>" +
                    '<strong style="color: #FFFFFF; text-transform: capitalize; font-size: 16px; font-weight: bold;">' +
                    moment(iconsDaily[this.value].date, "YYYY-MM-DD")
                      .tz("America/Sao_Paulo")
                      .locale("pt-br")
                      .format("ddd") +
                    "</strong>" +
                    "<br>" +
                    '<i class="icon-infohidro-wi-day-cloudy" style="color: transparent; font-size: 40px"></i>'
                  );
                }
              },
            },
            type: "datetime",
            /*            labels: {
              format: "{value: %d/%m <br> %a}",
              style: { color: "#FFFFFF" },
            },*/
            title: {
              enabled: false,
              style: { color: "#FFFFFF" },
            },
          },
          yAxis: [
            {
              visible: false,
              reversed: false,
              opposite: false,
              min: 0,
              height: "70%",
            },
            {
              visible: false,
              reversed: true,
              opposite: true,
              min: 0,
              top: "60%",
              height: "30%",
              offset: 0,
            },
          ],
          plotOptions: {
            series: {
              marker: { enabled: false },
            },
          },
          colors: ["#0071B0", "#ff5700", "#FF9F00"],
          tooltip: {
            useHTML: true,
            backgroundColor: "#212a35",
            borderWidth: 0,
            formatter: function () {
              return this.points.reduce(function (s, point) {
                return (
                  s +
                  '<div style="background-color: #212a35">' +
                  "<br/>" +
                  '<b style="color:' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ": " +
                  "</b>" +
                  '<b style="color: #FFFFFF">' +
                  point.y.toFixed(point.series.tooltipOptions.valueDecimals) +
                  point.series.tooltipOptions.valueSuffix +
                  "</b>"
                );
              }, '<b style="text-transform: capitalize; color: #FFFFFF">' +
                moment.utc(this.x).locale("pt-br").format(Dateformat) +
                "</b>" +
                "<br/>" +
                '<b style="color: #FFFFFF">' +
                iconsDaily[this.x].text +
                "</b>" +
                "<br/>" +
                "</div>");
            },
            shared: true,
            crosshairs: true,
          },
          series: [
            {
              name: "Precipitação",
              type: "column",
              yAxis: 1,
              data: this.arrayPrecDaily,
              tooltip: {
                valueDecimals: 1,
                valueSuffix: "mm",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}mm',
                formatter: function () {
                  return this.y.toFixed(1) + "mm";
                },
                verticalAlign: "top",
                style: { color: "#FFFFFF" },
              },
            },
            {
              name: "Temperatura Máxima",
              type: "line",
              yAxis: 0,
              data: this.arrayTempMax,
              tooltip: {
                valueDecimals: 0,
                valueSuffix: "°C",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}˚C',
                formatter: function () {
                  return this.y.toFixed(0) + "˚C";
                },
                verticalAlign: "bottom",
                style: { color: "#FFFFFF" },
              },
            },
            {
              name: "Temperatura Mínima",
              type: "line",
              yAxis: 0,
              data: this.arrayTempMin,
              tooltip: {
                valueDecimals: 0,
                valueSuffix: "°C",
              },
              dataLabels: {
                enabled: true,
                //format: '{y}˚C',
                formatter: function () {
                  return this.y.toFixed(0) + "˚C";
                },
                verticalAlign: "top",
                style: { color: "#FFFFFF" },
              },
            },
          ],
          caption: this.caption,
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  plotOptions: {
                    series: {
                      marker: {
                        radius: 2.5,
                      },
                    },
                  },
                },
              },
            ],
          },
          exporting: {
            enabled: false,
          },
        });
      }
    },

    dateToUTC(x) {
      let utc = moment(x, "YYYY-MM-DD").locale("pt-br").format("YYYY-MM-DD");
      x = moment.utc(utc).locale("pt-br").valueOf();
      return x;
    },
    datetimeToUTC(x) {
      let utc = moment(x, "YYYY-MM-DD HH:mm:ss")
        .locale("pt-br")
        .format("YYYY-MM-DD HH:mm:ss");
      x = moment.utc(utc).locale("pt-br").unix() * 1000;
      return x;
    },
    verifySummaryId(summaryId) {
      let icone;
      if (summaryId == 4) {
        icone = "icon-infohidro-day-wi-cloudy";
      } else if (summaryId == 6) {
        icone = "icon-infohidro-wi-rain";
      } else if (summaryId == 8) {
        icone = "icon-infohidro-wi-snowflake-cold";
      } else if (summaryId == 9) {
        icone = "icon-infohidro-wi-snow";
      } else if (summaryId == 11) {
        icone = "icon-infohidro-wi-fog";
      } else {
        icone = "icon-infohidro-day-wi-cloudy";
      }
      return icone;
    },
    mapIcon(id, date) {
      let icon,
        isDay = true;
      if (this.item.text === "15 dias") {
        isDay = true;
      } else {
        let holder = moment(date, "YYYY-MM-DDTHH:mm:ssZ")
          .tz("America/Sao_Paulo")
          .format("HH");
        if (holder <= "06" || holder >= "18") {
          isDay = false;
        }
      }
      if (id == 4) {
        icon = "icon-infohidro-wi-cloud";
      } else if (id == 6) {
        icon = "icon-infohidro-wi-rain";
      } else if (id == 7) {
        icon = "icon-infohidro-wi-thunderstorm";
      } else if (id == 8) {
        icon = "icon-infohidro-wi-snowflake-cold";
      } else if (id == 9) {
        icon = "icon-infohidro-wi-snow";
      } else if (id == 11) {
        icon = "icon-infohidro-wi-fog";
      } else if (id == 999) {
        icon = " ";
      }
      if (isDay == true) {
        if (id == 1) {
          icon = "icon-infohidro-wi-day-sunny";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-day-sunny-overcast";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-day-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-day-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-day-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      } else if (isDay == false) {
        if (id == 1) {
          icon = "icon-infohidro-wi-night-clear";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-night-alt-partly-cloudy";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-night-alt-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-night-alt-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-night-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      }
      return icon;
    },
    mapText(id) {
      let text;
      if (id == 4) {
        text = "Nublado";
      } else if (id == 6) {
        text = "Chuva";
      } else if (id == 7) {
        text = "Tempestade";
      } else if (id == 8) {
        text = "Geada";
      } else if (id == 9) {
        text = "Neve";
      } else if (id == 11) {
        text = "Neblina";
      } else if (id == 1) {
        text = "Céu Claro";
      } else if (id == 2) {
        text = "Poucas Nuvens";
      } else if (id == 3) {
        text = "Muitas Nuvens";
      } else if (id == 5) {
        text = "Parcialmente nublado com pancadas de chuva";
      } else if (id == 10) {
        text = "Parcialmente Nublado com chuvas e trovoadas";
      } else {
        text = " ";
      }
      return text;
    },
  },
};
</script>

<style>
.highcharts-tick {
  color: transparent;
}
</style>
